import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();
  const prevPathname = useRef(pathname);

  useEffect(() => {
    const prev = prevPathname.current;
    const current = pathname;

    const drinkMenuPattern = /^\/(bexley|eltham)\/drinks(\/|$)/;
    const shouldSkipScroll =
      drinkMenuPattern.test(prev) && drinkMenuPattern.test(current);

    if (!shouldSkipScroll) {
      window.scrollTo(0, 0);
    }

    prevPathname.current = pathname;
  }, [pathname]);

  return null;
}
